import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postUserTenantConnection = (token, TenantID, UserID, TenantRole, TenantEmployeeID) => {
    return fetch(`${apiUrl}user_tenant_connections`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            TenantID,
            UserID,
            TenantRole,
            TenantEmployeeID
        })
    });
}

export default postUserTenantConnection